import type { TOC } from '@ember/component/template-only';
import {
  PrismButton,
  PrismLoadingBar,
  PrismModal,
  PrismPagination,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import HotelAndMarketFormFieldsHotelOrMarketSearch from 'lumen/components/hotel-and-market/form-fields/hotel-or-market-search';
import HotelAndMarketFormFieldsSingleUserSearch from 'lumen/components/hotel-and-market/form-fields/single-user-search';
import SettingsHotelAccessFormsFormAddUserToHotel from 'lumen/components/settings/hotel-access/forms/form-add-user-to-hotel';
import SettingsHotelAccessTablesTableHotelAccess from 'lumen/components/settings/hotel-access/tables/table-hotel-access';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type HotelSettingsHotelsController from 'lumen/controllers/hotel/settings/hotels';

interface HotelSettingsHotelsSignature {
  Args: {
    controller: HotelSettingsHotelsController;
    model: unknown;
  };
}

<template>
  {{#if @controller.model.isLoading}}
    <PrismLoadingBar @isFixed={{true}} @positionTop={{60}} />
  {{/if}}

  <SettingsPageTemplate
    @description={{t "settings.hotel_access.description"}}
    @isFullHeight={{true}}
    @title={{t "settings.section.hotel_access"}}
  >
    <:headerAfter>
      <PrismButton
        @iconBefore="plus"
        @label={{t "general.add_user"}}
        @onClick={{@controller.showAddUserToHotelModal}}
        data-test-id="add-user-button"
      />
    </:headerAfter>
    <:default>
      <div class="flex h-full flex-col">
        <div class="settings-hotels-container flex flex-grow flex-col">
          <div class="settings-hotel-access-table-extra-header">
            <div
              class="settings-hotel-access-table-filter-wrapper flex items-center gap-200"
            >
              <HotelAndMarketFormFieldsSingleUserSearch
                @selectItem={{@controller.selectUser}}
                @selectedOption={{@controller.selectedUser}}
              />

              <HotelAndMarketFormFieldsHotelOrMarketSearch
                @hotelOnly={{true}}
                @selectItem={{@controller.selectHotelOrMarket}}
                @selectedOption={{@controller.selectedHotelOrMarket}}
              />
            </div>
          </div>

          <SettingsHotelAccessTablesTableHotelAccess
            @doRefresh={{@controller.doRefresh}}
            @isLoading={{@controller.model.isLoading}}
            @model={{@controller.model.users}}
            {{! @glint-expect-error: Incorrect type }}
            @name="hotel-access-table"
          />
        </div>

        <div class="pagination-row-container">
          <PrismPagination
            @lastPage={{@controller.model.totalPages}}
            @page={{@controller.page}}
            @setPage={{@controller.setPage}}
          />
        </div>
      </div>
    </:default>
  </SettingsPageTemplate>

  {{#if @controller.isAddUserToHotelDialogVisible}}
    <PrismModal
      @onClose={{@controller.closeAddUserToHotelModal}}
      @title={{t "settings.hotel_access.add_user"}}
    >
      <SettingsHotelAccessFormsFormAddUserToHotel
        @closeModal={{@controller.closeAddUserToHotelModal}}
        @doRefresh={{@controller.doRefresh}}
      />
    </PrismModal>
  {{/if}}

  {{outlet}}
</template> satisfies TOC<HotelSettingsHotelsSignature>;
